/**
 * Recent items management (localStorage)
 */

import { RECENT_EMOJIS_KEY, RECENT_ICONS_KEY, MAX_RECENT } from '../constants';

// Get recent emojis from localStorage
export const getRecentEmojis = () => {
  try {
    return JSON.parse(localStorage.getItem(RECENT_EMOJIS_KEY) || '[]');
  } catch { 
    return []; 
  }
};

// Get recent icons from localStorage
export const getRecentIcons = () => {
  try {
    return JSON.parse(localStorage.getItem(RECENT_ICONS_KEY) || '[]');
  } catch { 
    return []; 
  }
};

// Add emoji to recent list
export const addRecentEmoji = (emoji) => {
  const recent = getRecentEmojis().filter(e => e !== emoji);
  recent.unshift(emoji);
  localStorage.setItem(RECENT_EMOJIS_KEY, JSON.stringify(recent.slice(0, MAX_RECENT)));
};

// Add icon to recent list
export const addRecentIcon = (iconName) => {
  const recent = getRecentIcons().filter(n => n !== iconName);
  recent.unshift(iconName);
  localStorage.setItem(RECENT_ICONS_KEY, JSON.stringify(recent.slice(0, MAX_RECENT)));
};

